import React from "react";
import App from "../adminDashboard/App";
// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "../../context";

export default function Admin(props){
    return(
        <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    )
}

